/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVisitorTabDto } from '../../models/create-visitor-tab-dto';
import { PosTab } from '../../models/pos-tab';

export interface PosTabsControllerCreateVisitorTab$Params {
      body: CreateVisitorTabDto
}

export function posTabsControllerCreateVisitorTab(http: HttpClient, rootUrl: string, params: PosTabsControllerCreateVisitorTab$Params, context?: HttpContext): Observable<StrictHttpResponse<PosTab>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerCreateVisitorTab.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PosTab>;
    })
  );
}

posTabsControllerCreateVisitorTab.PATH = '/pos/tabs/visitor';
